.backdrop {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: rgba(21, 23, 31, 0.45);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  animation: fade var(--vc-duration) var(--vc-ease);

  /* Drawer variant slides in from the right */
  &.drawerBackdrop {
    justify-content: flex-end;
    padding: 0;
  }
}

.dialog {
  width: 100%;
  max-width: var(--modal-w, 560px);
  max-height: calc(100vh - 32px);
  background: var(--vc-surface);
  border-radius: var(--vc-radius-xl);
  box-shadow: var(--vc-shadow-lg);
  display: flex;
  flex-direction: column;
  animation: rise 200ms var(--vc-ease);
  outline: none;

  &.sm {
    --modal-w: 420px;
  }
  &.md {
    --modal-w: 560px;
  }
  &.lg {
    --modal-w: 760px;
  }
  &.xl {
    --modal-w: 980px;
  }

  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 20px 22px 0;
  }

  .title {
    font-size: var(--vc-text-lg);
    font-weight: var(--vc-weight-semibold);
  }

  .description {
    margin-top: 4px;
    font-size: var(--vc-text-sm);
    color: var(--vc-text-muted);
  }

  .body {
    padding: 18px 22px;
    overflow-y: auto;
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding: 14px 22px 20px;
    border-top: 1px solid var(--vc-border);
  }

  &.drawer {
    max-width: var(--modal-w, 520px);
    max-height: 100vh;
    height: 100vh;
    border-radius: 0;
    animation: slide 220ms var(--vc-ease);
  }
}

@keyframes fade {
  from {
    opacity: 0;
  }
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
}

@keyframes slide {
  from {
    transform: translateX(24px);
    opacity: 0;
  }
}
